import {
  PaymentOption,
  PaymentType,
} from '@/modules/checkout/_core/domain/entities'

export const TABS = [
  PaymentOption.CreditCard,
  PaymentOption.BankSlip,
  PaymentOption.Pix,
]

export const getTabKey = (paymentType: PaymentType) =>
  paymentType.type === PaymentOption.Redirect
    ? `${PaymentOption.Redirect}-${paymentType.id}`
    : paymentType.type
